<template>
  <div>
    <InsightsLeftPanelLite v-if="isLite"></InsightsLeftPanelLite>
    <InsightsLeftPanelFull v-else></InsightsLeftPanelFull>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useDrawer } from '@app/shared/pinia/drawer'
import { LeftDrawerContent } from '@app/shared/types/drawer'
import InsightsLeftPanelFull from './insights-left-panel-full.vue'
import InsightsLeftPanelLite from './insights-left-panel-lite.vue'

interface Props {
  isLite: boolean
}
defineProps<Props>()

const drawerStore = useDrawer()

onMounted(() => {
  const preference = window?.Silverfin?.currentUserPreferences?.open_sidepane

  if (preference?.position === 'left' && preference?.content === 'default') {
    drawerStore.openDrawerDefault({
      direction: 'left',
      content: LeftDrawerContent.Default,
    })
  }
})
</script>
